// src/services/userService.js
import API from './address';
import { getRequest } from './apiService';

/**
 * 用户信息服务模块
 * 负责用户信息的获取、存储和管理
 */
class UserService {
  constructor() {
    this.userProfile = null;
    this.isLoading = false;
  }

  /**
   * 获取用户完整信息
   * @returns {Promise<Object|null>} 用户信息对象或null
   */
  async getUserProfile() {
    // 如果正在加载中，等待当前请求完成
    if (this.isLoading) {
      return null;
    }

    try {
      this.isLoading = true;
      
      const response = await getRequest(API.getUserProfile);
      
      if (response.success) {
        this.userProfile = response.data;
        
        return this.userProfile;
      } else {
        console.error('获取用户信息失败:', response.message);
        
        // 如果是认证失败，清除本地存储
        if (response.code === 'UNAUTHORIZED') {
          this.clearUserData();
        }
        
        return null;
      }
    } catch (error) {
      console.error('获取用户信息异常:', error);
      
      // 如果是401错误，清除本地存储
      if (error.response && error.response.status === 401) {
        this.clearUserData();
      }
      
      return null;
    } finally {
      this.isLoading = false;
    }
  }


  /**
   * 清除用户数据
   */
  clearUserData() {
    this.userProfile = null;
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('lastTokenValidation');
    console.log('用户数据已清除');
  }

  /**
   * 更新用户信息
   * @param {Object} updates 要更新的字段
   */
  updateUserProfile(updates) {
    if (this.userProfile) {
      this.userProfile = { ...this.userProfile, ...updates };
    }
  }

  /**
   * 获取当前用户信息
   * @returns {Object|null} 当前用户信息
   */
  getCurrentUserProfile() {
    return this.userProfile;
  }

  /**
   * 格式化学习时间
   * @param {number} seconds 秒数
   * @returns {string} 格式化后的时间字符串
   */
  formatStudyTime(seconds) {
    if (!seconds || seconds === 0) {
      return '0分钟';
    }
    
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      if (minutes > 0) {
        return `${hours}小时${minutes}分钟`;
      } else {
        return `${hours}小时`;
      }
    } else if (minutes > 0) {
      return `${minutes}分钟`;
    } else {
      return `${secs}秒`;
    }
  }

  /**
   * 获取用户等级显示文本
   * @param {number} level 用户等级
   * @returns {string} 等级显示文本
   */
  getLevelText(level) {
    return `Lv.${level || 1}`;
  }

  /**
   * 检查用户是否已激活
   * @returns {boolean} 是否已激活
   */
  isUserActive() {
    return this.userProfile && this.userProfile.isActive === 1;
  }

  /**
   * 检查用户状态是否正常
   * @returns {boolean} 状态是否正常
   */
  isUserStatusNormal() {
    return this.userProfile && this.userProfile.status === 1;
  }
}

// 创建单例实例
const userService = new UserService();

export default userService;
